import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/client';

function JinglesForm({ editMode = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    media_file_id: '',
    trigger_type: 'interval_songs',
    trigger_value: 5,
    priority: 0,
    is_active: true,
  });

  useEffect(() => {
    if (editMode && id) loadJingle();
  }, [id, editMode]);

  async function loadJingle() {
    try {
      const res = await api.get(`/api/jingles/${id}`);
      setFormData(res.data);
    } catch (err) {
      console.error('Failed to load jingle', err);
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await api.put(`/api/jingles/${id}`, formData);
      } else {
        await api.post('/api/jingles', formData);
      }
      navigate('/jingles');
    } catch (err) {
      console.error('Failed to save jingle', err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-bold text-dark-100">
        {editMode ? 'Edit Jingle' : 'Add New Jingle'}
      </h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-dark-300">Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} className="input" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Media File ID</label>
          <input type="text" name="media_file_id" value={formData.media_file_id} onChange={handleChange} className="input" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Trigger Type</label>
          <select name="trigger_type" value={formData.trigger_type} onChange={handleChange} className="input">
            <option value="interval_songs">Every X Songs</option>
            <option value="interval_minutes">Every X Minutes</option>
            <option value="show_start">Show Start</option>
            <option value="show_end">Show End</option>
            <option value="specific_time">Specific Time</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Trigger Value</label>
          <input type="number" name="trigger_value" value={formData.trigger_value} onChange={handleChange} className="input" min="0" />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Priority</label>
          <input type="number" name="priority" value={formData.priority} onChange={handleChange} className="input" />
        </div>
        <button type="submit" className="btn btn-primary">Save</button>
      </form>
    </div>
  );
}

export default JinglesForm;
